// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"measurement"},"children":[{"tag":"path","attrs":{"id":"fill1","fill":"props.fillColor1","d":"M7 2L17 2V22H7L7 2Z"}},{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M7 7H9.5M7 12H11M7 17H9.5M7 2H17V22H7V2Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const MeasurementIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'measurement',
    ref,
    icon: element,
  },
));

MeasurementIcon.displayName = 'MeasurementIcon';

export default MeasurementIcon;
